<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>

export default {
  data() {
    return {
    };
  },
  created() {
  },
};
</script>
<style>
#app {
  width: 100%;
  height: 100%;
  color: #2c3e50;
  font-family: "PingFang SC", miui, system-ui, -apple-system, BlinkMacSystemFont,
    Helvetica Neue, Helvetica, sans-serif;
  text-align: center;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: #f8f8f9;
}
.van-hairline--top-bottom::after,
.van-hairline-unset--top-bottom::after {
  border-width: 0 0 !important;
}

.van-cell:not(:last-child)::after {
  right: 16px !important;
}
.term::after {
  right: 16px !important;
}
.van-toast {
  z-index: 99999 !important;
}
</style>
